import { fromJS } from "immutable";
import { Action, reducerFn, ReducerState } from "../../helpers/reducers";
import { DOC_USER_SET, DOC_USER_CLEAR, DOC_USER_REMOVE } from "./actions";

interface DocUsers {
    doc_id: string;
    user_id: string;
}
type DocUsersAction = Action<DocUsers>;

function getId(payload: DocUsers) {
    return `${payload.doc_id}-${payload.user_id}`;
}

const fnMap = {
    [DOC_USER_CLEAR]: (s: ReducerState) => s.clear(),
    [DOC_USER_SET]: (s: ReducerState, { payload }: DocUsersAction) => {
        if (!getId(payload)) {
            return s;
        }

        return s.set(getId(payload), fromJS(payload));
    },
    [DOC_USER_REMOVE]: (s: ReducerState, { payload }: DocUsersAction) =>
        s.delete(getId(payload)),
};

const initialState = {};
export const docUsersReducer = reducerFn("doc_users", initialState, fnMap);
